// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab--tab--1k-ge","selected":"Tab--selected--2h44y"};